import React, { useState } from 'react'
import { Menu, MenuItem, MenuList, Paper } from '@mui/material'
import { MoreButton } from 'common/Button/MoreButton'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
import OrbitSession from 'hooks/useCookies'
import RefundUpdateStatusDialogV2 from 'pages/Customers/vendor/Faber/v2-customer-components/RefundUpdateStatusDialogV2'
import { RefundRequestsType } from 'types/api/faber/payment.type'

import FaberViewRefundMoreInfo from './FaberViewRefundMoreInfo'

const useDialog = () => {
  const [modalState, setModalState] = useState(false)

  function closeDialog() {
    setModalState(false)
  }

  function openDialog() {
    setModalState(true)
  }

  return {
    modalState,
    closeDialog,
    openDialog
  }
}

const FaberRefundMenu = ({
  paymentRow,
  updateRow,
  role
}: FaberFinanceRefundProps) => {
  const faberToken = OrbitSession.get('faberToken')
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const {
    modalState: viewRefundDialog,
    closeDialog: closeViewRefundDialog,
    openDialog: openViewRefundDialog
  } = useDialog()

  const {
    modalState: isViewRefundOpen,
    closeDialog: closeRefundUpdateDialog,
    openDialog: openRefundUpdateDialog
  } = useDialog()

  return (
    <>
      <MoreButton disabled={role !== 'opsowner'} onClick={handleMenuOpen} />
      <Paper>
        <MenuList dense>
          <Menu
            id='action-menu'
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button'
            }}
          >
            <MenuItem
              onClick={() => {
                handleMenuClose()
                openViewRefundDialog()
              }}
            >
              <TextColorFontBody
                sx={{
                  color: circlesOrbitColorPalette.neutrals[600],
                  fontSize: '12px'
                }}
              >
                More Information
              </TextColorFontBody>
            </MenuItem>
            <MenuItem
              disabled={paymentRow.refundStatus === 'SUCCESS'}
              onClick={openRefundUpdateDialog}
            >
              <TextColorFontBody
                sx={{
                  color: circlesOrbitColorPalette.neutrals[600],
                  fontSize: '12px'
                }}
              >
                Update Refund Status
              </TextColorFontBody>
            </MenuItem>
          </Menu>
        </MenuList>
      </Paper>
      <FaberViewRefundMoreInfo
        updateRow={updateRow}
        paymentRow={paymentRow}
        handleClose={closeViewRefundDialog}
        dialogOpen={viewRefundDialog}
      />
      <RefundUpdateStatusDialogV2
        dialogOpen={isViewRefundOpen}
        handleDialogClose={closeRefundUpdateDialog}
        paymentId={paymentRow.refundPaymentId}
        faberToken={faberToken}
      />
    </>
  )
}

interface FaberFinanceRefundProps {
  paymentRow: RefundRequestsType
  updateRow: () => void
  role: string
}

export default FaberRefundMenu
